import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// views
import About from '../views/About';
import Fuse from '../views/Fuse';
import Fusions from '../views/Fusions';
import Launchpad from '../views/Launchpad';
import Launchplans from '../views/Launchplans';
import Login from '../views/Login';
import Pitches from '../views/Pitches';
import Project from '../views/Project';
import Tutorial from '../views/Tutorial';

const MainView = ({
  projects,
  fetchProject,
  isFetchingProjects,
  fuses,
  fetchFuse,
  isFetchingFuses,
  pitches,
  isFetchingPitches,
  fuseShareId,
  handleViewChange,
  // currentView,
  handleOpenModal,
  inputs,
  handleInputsChange,
  currentQuestion,
  handleQuestionChange,
  handleCreateProject,
  projectThread,
  projectFuseList,
  projectConvo,
  projectLoading,
  updatingProjectList,
  handleUpdateProjectConvo,
  loadingMessage,
  handleCreateFuse,
  fuseLoadingList,
  fuseLoading,
  fuseSavedData,
  fuseLoadingData,
  handleUserLoggedIn,
  onRegisterSuccess,
  sidebarOpen,
  mobileSidebarOpen,
  setSidebarOpen,
  createPitch,
  loadingPitchesArray,
  deckLink,
  renamePitch,
  renameFuse,
  renameProject,
  backInfo,
  pinImage,
  retryFetchFuseData,
  helpOpen,
  toggleHelp
}) => {
  return (
    <div
      className={
        mobileSidebarOpen
          ? 'fuselight-v5-main-view mobile-sidebar-open'
          : 'fuselight-v5-main-view'
      }
    >
      <Switch>
        <Route path="/launchpad">
          <Launchpad
            inputs={inputs}
            handleInputsChange={handleInputsChange}
            currentQuestion={currentQuestion}
            handleQuestionChange={handleQuestionChange}
            handleCreateProject={handleCreateProject}
            helpOpen={helpOpen}
            toggleHelp={toggleHelp}
          />
        </Route>
        <Route path="/fuse">
          <Fuse
            fuseLoading={fuseLoading}
            fuseSavedData={fuseSavedData}
            fuseLoadingData={fuseLoadingData}
            fuseLoadingList={fuseLoadingList}
            handleOpenModal={handleOpenModal}
            fuseShareId={fuseShareId}
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            handleViewChange={handleViewChange}
            fetchProject={fetchProject}
            backInfo={backInfo}
            pinImage={pinImage}
            retryFetchFuseData={retryFetchFuseData}
            projectFuseList={projectFuseList}
            projects={projects}
            createPitch={createPitch}
            loadingPitchesArray={loadingPitchesArray}
            deckLink={deckLink}
            helpOpen={helpOpen}
            toggleHelp={toggleHelp}
          />
        </Route>
        <Route path="/project">
          <Project
            inputs={inputs}
            projectThread={projectThread}
            projectFuseList={projectFuseList}
            projectConvo={projectConvo}
            projectLoading={projectLoading}
            updatingProjectList={updatingProjectList}
            handleInputsChange={handleInputsChange}
            handleUpdateProjectConvo={handleUpdateProjectConvo}
            loadingMessage={loadingMessage}
            handleCreateFuse={handleCreateFuse}
            fuseLoadingList={fuseLoadingList}
            fetchFuse={fetchFuse}
            createPitch={createPitch}
            loadingPitchesArray={loadingPitchesArray}
            deckLink={deckLink}
            helpOpen={helpOpen}
            toggleHelp={toggleHelp}
          />
        </Route>
        <Route path="/launchplans">
          <Launchplans
            projects={projects}
            dashboardLoading={isFetchingProjects}
            handleOpenModal={handleOpenModal}
            fetchProject={fetchProject}
            handleViewChange={handleViewChange}
            renameProject={renameProject}
          />
        </Route>
        <Route path="/fusions">
          <Fusions
            fuses={fuses}
            dashboardLoading={isFetchingFuses}
            handleOpenModal={handleOpenModal}
            fetchFuse={fetchFuse}
            handleViewChange={handleViewChange}
            renameFuse={renameFuse}
          />
        </Route>
        <Route path="/pitches">
          <Pitches
            pitches={pitches}
            dashboardLoading={isFetchingPitches}
            handleOpenModal={handleOpenModal}
            handleViewChange={handleViewChange}
            renamePitch={renamePitch}
          />
        </Route>
        <Route path="/login">
          <Login
            handleUserLoggedIn={handleUserLoggedIn}
            onRegisterSuccess={onRegisterSuccess}
          />
        </Route>
        <Route path="/about">
          <About handleViewChange={handleViewChange} />
        </Route>
        <Route path="/tutorial">
          <Tutorial />
        </Route>
        <Route>
          <Redirect to="/launchpad" />
        </Route>
      </Switch>
    </div>
  );
};

export default MainView;
